import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {LocalStorageService} from '@services/local-storage.service';
import {NotificationService} from '@notifications';

@Injectable({
  providedIn: 'root',
})
export class PdfConverterProgressPopupService {
  private readonly openedSubject = new BehaviorSubject<boolean>(false);
  readonly opened$ = this.openedSubject.asObservable();
  private readonly dismissedForSessionSubject = new BehaviorSubject<boolean>(false);
  readonly dismissedForSession$ = this.dismissedForSessionSubject.asObservable();

  constructor(
    private localStorageService: LocalStorageService,
    private notificationService: NotificationService,
  ) {}

  get opened(): boolean {
    return this.openedSubject.value;
  }

  get dismissedForSession(): boolean {
    return this.dismissedForSessionSubject.value;
  }

  open() {
    if (!this.opened) {
      this.openedSubject.next(true);
    }
  }

  close() {
    if (this.opened) {
      this.openedSubject.next(false);
    }
  }

  toggle() {
    this.opened ? this.close() : this.open();
  }

  loadDismissedState() {
    this.dismissedForSessionSubject.next(
      this.localStorageService.getValue(this.getDismissedKey()) === '1',
    );
  }

  dismissForSession(showNotification: boolean = true) {
    this.localStorageService.setValue(this.getDismissedKey(), '1');
    this.dismissedForSessionSubject.next(true);
    if (showNotification) {
      this.notificationService.success('Progress can be tracked at Tools -> PDF Converter page');
    }
  }

  clearDismissedForSession() {
    this.localStorageService.removeItem(this.getDismissedKey());
    this.dismissedForSessionSubject.next(false);
  }

  private getDismissedKey(): string {
    return `pdf-converter-progress-hidden.${this.localStorageService.getCurrentUsername()}`;
  }
}
